import React from "react";

const mockQuestion = {
  key : 1,
  qusNumber : 1,
  question: "What is the capital of France?",
  options: ["Berlin", "Madrid", "Paris", "Rome"],
  correctAnswer: "Paris",
  userAnswer: "Madrid"
};

const QuizCard = ({ key, qusNumber, question , options, correctAnswer, userAnswer } = mockQuestion) => {
  return (
     <div className="card bg-base-100 shadow-xl p-6 w-full">
      <h2 className="card-title mb-4 text-left">{`${qusNumber}. ${question}`}</h2>
      <div className="form-control">
        {options.map((option, index) => {
          const isCorrect = option === correctAnswer;
          const isUser = option === userAnswer;

          let optionClasses = "label cursor-pointer justify-between border rounded-lg p-3 mb-2";
          let labelText = "";

          if (isCorrect && isUser) {
            optionClasses += " border-green-500 bg-green-100";
            labelText = "✅ Right Answer & You answered";
          } else if (isCorrect) {
            optionClasses += " border-green-500 bg-green-100";
            labelText = "✅ Right Answer";
          } else if (isUser && !isCorrect) {
            optionClasses += " border-red-500 bg-red-100";
            labelText = "❌ You answered";
          } else {
            optionClasses += " border-gray-300";
          }

          return (
            <div key={index} className={optionClasses}>
              <span className="flex items-center">
                <input
                  type="checkbox"
                  checked={isUser}
                  readOnly
                  className="checkbox mr-2"
                />
                <span>{String.fromCharCode(65 + index)}. {option}</span>
              </span>
              {labelText && <span className="text-sm ml-2 text-left">{labelText}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuizCard;
